import { gql } from '@apollo/client'

import { INVENTORY_ORDER_FIELDS } from '../fragments'

export const FETCH_INVENTORY_ORDERS_PAGE = gql`
  ${INVENTORY_ORDER_FIELDS}
  query FetchInventoryOrders($input: InventoryOrdersInput!) {
    inventoryOrders(input: $input) {
      totalCount
      data {
        ...InventoryOrderFields
      }
    }
  }
`

export const FETCH_INVENTORY_ORDER_BY_ID = gql`
  ${INVENTORY_ORDER_FIELDS}
  query FetchInventoryOrder($id: ID!) {
    inventoryOrder(id: $id) {
      ...InventoryOrderFields
    }
  }
`
